// extracted by mini-css-extract-plugin
export default {"branch-loading-state":"BranchLoadingState_branch-loading-state__Z927G"};